import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../ui/gzForm/validators/required.validator';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../../ui/gzForm/formField';
import { GzDropdownWebComponent } from '../../../../../../../../ui/gzDropdown';
import { GzInputWebComponent } from '../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB_ACCESS_EXCEPTIONS_ITEM } from '../../../../../../../../webcomponents.constants';
import { getWebAccessPermissionFormOptions } from '../../../../../utils/uiSettings/contentControl/content-control.values';
import { ContentControlWebAccessRulePermission } from '@nirvana/shared/dtos/types/policies/common';

@customElement(WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB_ACCESS_EXCEPTIONS_ITEM)
export class GzContentControlWebAccessExceptionsItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#excludedItemWebAddress')
  excludedItemWebAddress: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#excludedItemPermission')
  excludedItemPermission: GzFormFieldWebComponent<GzDropdownWebComponent>;

  public setError(error: string) {
    this.excludedItemWebAddress.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field input--w70">
        <gz-form-field id="excludedItemWebAddress">
          <gz-input
            gz-form-input
            label="${translateFn('Web address')}"
            placeholder="${translateFn('URL')}"
          ></gz-input>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field">
        <gz-form-field id="excludedItemPermission">
          <gz-single-select
            cannotDelete
            gz-form-input
            .value="${ContentControlWebAccessRulePermission.BLOCK}"
            label="${translateFn('Permission')}"
            filterOptions="${JSON.stringify(getWebAccessPermissionFormOptions())}"
          ></<gz-single-select>
        </gz-form-field>
      </div>
    `;
  }

  createFormGroup(): void {
    this.excludedItemWebAddress.Validators = [RequiredValidator(translateFn('Required field'))];
    this.excludedItemPermission.Validators = [RequiredValidator(translateFn('Required field'))];

    this.formGroup = new FormGroup({
      webAddress: this.excludedItemWebAddress,
      permission: this.excludedItemPermission,
    });
  }

  resetForm(resetType = true): void {
    if (resetType) {
      this.excludedItemPermission.value = ContentControlWebAccessRulePermission.BLOCK;
      this.excludedItemPermission.resetField();
    }

    this.excludedItemWebAddress.value = '';
    this.excludedItemWebAddress.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm(false);
  }
}
